import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cart--sprite",
  "use": "cart--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"cart--sprite\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#565D60\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <path d=\"M3.5 7.5h3.919l1.587 10.583 1.047 3.334h14.476\" />\n        <path d=\"M7.787 9.195l19.323 1.528-2.233 7.29-15.872.07M23.278 23.751a1.925 1.925 0 1 1-3.85 0 1.925 1.925 0 0 1 3.85 0zM14.637 23.751a1.925 1.925 0 1 1-3.85 0 1.925 1.925 0 0 1 3.85 0z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol